import { css } from '@emotion/react';
import React from 'react';
import { useFormContext } from 'react-hook-form';

import { AdditionalInfoFormFields } from '@/booking/validators/additional-info-form.validator';
import { Box, Flex } from '@/box';
import { useFlexyTimeOptions } from '@/flexy-time';
import { useTranslation } from '@/i18n';
import { Select } from '@/ui/form';
import { Spacer } from '@/ui/spacing';
import { useTheme } from '@/ui/theme';
import { BodySmall, Heading } from '@/ui/typography';

export const FlexyTimeInputs = () => {
  const { t } = useTranslation('additionalInformation');
  const options = useFlexyTimeOptions();
  const { forms } = useTheme();

  const {
    register,
    formState: { errors },
    watch,
  } = useFormContext<
    Pick<AdditionalInfoFormFields, 'checkInTime' | 'checkOutTime'>
  >();

  const [checkInTime, checkOutTime] = watch(['checkInTime', 'checkOutTime']);

  return (
    <div>
      <Heading
        as="h6"
        style="heading6"
        css={css({
          ...forms.heading,
          ['@media all and (max-width: 730px)']: forms.heading?.mobile,
        })}
      >
        {t('flexyTime.title')}
      </Heading>
      <Spacer s="xxs" />
      <BodySmall opacity={0.56}>{t('flexyTime.description')}</BodySmall>
      <Spacer s="l" />
      <Flex
        css={css`
          .select-spectre.select-spectre {
            @media (max-width: 370px),
              (min-width: 731px) and (max-width: 780px) {
              font-size: 0.9rem;
            }
            @media (max-width: 345px) {
              font-size: 0.8rem;
            }
            @media (max-width: 330px) {
              font-size: 0.75rem;
            }
          }
        `}
      >
        <Box width={[1 / 2, 200]} paddingRight={[8]}>
          <Select
            label={t('flexyTime.form.labels.checkInTime')}
            placeholder={t('flexyTime.form.labels.unsure')}
            options={options}
            value={checkInTime || ''}
            error={errors.checkInTime?.message}
            {...register('checkInTime')}
          />
        </Box>
        <Box width={[1 / 2, 200]} paddingLeft={[8]}>
          <Select
            label={t('flexyTime.form.labels.checkOutTime')}
            placeholder={t('flexyTime.form.labels.unsure')}
            options={options}
            value={checkOutTime || ''}
            error={errors.checkOutTime?.message}
            {...register('checkOutTime')}
          />
        </Box>
      </Flex>
    </div>
  );
};

export default FlexyTimeInputs;
